module.exports = __webpack_public_path__ + "media/images/sports_icons/02-soccer-0f2354fa152db30b19909aa09c1d44b6.png";